export function cToUsdStrPref(cents: number): string {
  return `$${cToUsdStr(cents)}`;
}

export function cToUsdStr(cents: number): string {
  return (cents / 100).toFixed(2);
}
